__turbopack_context__.v({
  "polyvVideoLink": "EventSessionTemplate-module__mg1eSG__polyvVideoLink",
});
